module.exports = __webpack_public_path__ + "img/2-oneImg.4d3e577a.png";